import LensInfo from '@/app/_lens-components/components/LensInfo';
import { useLensProcessStore } from '@/app/_lens-components/store/lens-process-store';
import { processClassName } from '@/app/_lens-components/style/responsive';
import Image from '@/components/Image';
import ProductImageWithLenses from '@/components/Product/ProductImageWithLenses';

export default function ClientLeft({ isFrameProcess }: { isFrameProcess: boolean }) {
  const { lensGoodsItem, selectedColorItem, selectedBrand } = useLensProcessStore();

  return (
    <section
      className={`left-part ${processClassName.leftPart} bg-white xl:h-full box-border xl:overflow-y-auto pb-[100px] xl:pb-0`}
    >
      <div className={`left-side ${processClassName.leftPartSide} flex-1`} />
      <div className={`relative left-box flex-col  ${processClassName.leftPartBox}`}>
        {selectedColorItem?.lens_display_type === 2 &&
          !['non', 'pro'].includes(selectedBrand?.brand_title) && (
            <Image
              src="/lens-process/transitions-optical.png"
              alt=""
              width="75"
              height="20"
              className="w-[75px] absolute top-[62px] right-[46px]"
            />
          )}
        <ProductImageWithLenses
          className="w-full px-[27px] max-w-[534px] h-[auto] mt-[16vh] mb-[32px] aspect-[2/1]"
          imgUrl={lensGoodsItem?.product?.img || ''}
          blendFirst
          product={{
            background_image_of_mirror_leg:
              lensGoodsItem?.product?.image?.background_image_of_mirror_leg?.[0] || '',
            frame_background_image:
              lensGoodsItem?.product?.image?.frame_background_image?.[0] || '',
          }}
          lens={selectedColorItem}
        />
        <div className={processClassName.leftBottom}>
          <LensInfo isFrameProcess={isFrameProcess} />
        </div>
      </div>
    </section>
  );
}
